import { BASE_PATH as T, BaseAPI as B, operationServerMap as h } from "../base.js";
import { DUMMY_BASE_URL as p, assertParamExists as v, createRequestFunction as m, serializeDataIfNeeded as M, setSearchParams as R, toPathString as O } from "../common.js";
import u from "axios";
var P = function(r) {
  return {
    merchantTableRecordCancelTableRecord: async (n, l, t = {}) => {
      v("merchantTableRecordCancelTableRecord", "tableRecordId", n), v("merchantTableRecordCancelTableRecord", "cancelReason", l);
      const a = "/merchant/table/record/cancel/{tableRecordId}".replace("{tableRecordId}", encodeURIComponent(String(n))), e = new URL(a, p);
      let o;
      r && (o = r.baseOptions);
      const c = {
        method: "POST",
        ...o,
        ...t
      }, s = {}, d = {};
      l !== void 0 && (d.cancelReason = l), R(e, d);
      let i = o && o.headers ? o.headers : {};
      return c.headers = {
        ...s,
        ...i,
        ...t.headers
      }, {
        url: O(e),
        options: c
      };
    },
    merchantTableRecordMovingTableJson: async (n, l = {}) => {
      v("merchantTableRecordMovingTableJson", "movingTableParamDTO", n);
      const t = new URL("/merchant/table/record/moving", p);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...l
      }, o = {}, c = {};
      o["Content-Type"] = "application/json", R(t, c);
      let s = a && a.headers ? a.headers : {};
      return e.headers = {
        ...o,
        ...s,
        ...l.headers
      }, e.data = M(n, e, r), {
        url: O(t),
        options: e
      };
    },
    merchantTableRecordOpenTable: async (n, l, t, a, e = {}) => {
      v("merchantTableRecordOpenTable", "merchantTableRecord", n);
      const o = new URL("/merchant/table/record/openTable", p);
      let c;
      r && (c = r.baseOptions);
      const s = {
        method: "POST",
        ...c,
        ...e
      }, d = {}, i = {};
      l !== void 0 && (i.clientRequestTime = l instanceof Date ? l.toISOString() : l), t !== void 0 && (i.openTableType = t), a !== void 0 && (i.reserveId = a), d["Content-Type"] = "application/json", R(o, i);
      let y = c && c.headers ? c.headers : {};
      return s.headers = {
        ...d,
        ...y,
        ...e.headers
      }, s.data = M(n, s, r), {
        url: O(o),
        options: s
      };
    },
    merchantTableRecordOpenTableByCustomer: async (n, l, t, a = {}) => {
      v("merchantTableRecordOpenTableByCustomer", "merchantTableRecord", n);
      const e = new URL("/merchant/table/record/openTable/customer", p);
      let o;
      r && (o = r.baseOptions);
      const c = {
        method: "POST",
        ...o,
        ...a
      }, s = {}, d = {};
      l !== void 0 && (d.openTableType = l), t !== void 0 && (d.reserveId = t), s["Content-Type"] = "application/json", R(e, d);
      let i = o && o.headers ? o.headers : {};
      return c.headers = {
        ...s,
        ...i,
        ...a.headers
      }, c.data = M(n, c, r), {
        url: O(e),
        options: c
      };
    },
    merchantTableRecordPreviewMovingTableBilling: async (n, l = {}) => {
      const t = new URL("/merchant/table/record/moving/preview", p);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...l
      }, o = {}, c = {};
      o["Content-Type"] = "application/json", R(t, c);
      let s = a && a.headers ? a.headers : {};
      return e.headers = {
        ...o,
        ...s,
        ...l.headers
      }, e.data = M(n, e, r), {
        url: O(t),
        options: e
      };
    },
    merchantTableRecordPreviewMovingTableBillingTypeUpdate: async (n, l = {}) => {
      v("merchantTableRecordPreviewMovingTableBillingTypeUpdate", "movingTableBillingTypeUpdateRequest", n);
      const t = new URL("/merchant/table/record/moving/billing-type/preview", p);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...l
      }, o = {}, c = {};
      o["Content-Type"] = "application/json", R(t, c);
      let s = a && a.headers ? a.headers : {};
      return e.headers = {
        ...o,
        ...s,
        ...l.headers
      }, e.data = M(n, e, r), {
        url: O(t),
        options: e
      };
    },
    merchantTableRecordRollbackMovingTable: async (n, l = {}) => {
      v("merchantTableRecordRollbackMovingTable", "movingTableRollbackRequest", n);
      const t = new URL("/merchant/table/record/moving/rollback", p);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...l
      }, o = {}, c = {};
      o["Content-Type"] = "application/json", R(t, c);
      let s = a && a.headers ? a.headers : {};
      return e.headers = {
        ...o,
        ...s,
        ...l.headers
      }, e.data = M(n, e, r), {
        url: O(t),
        options: e
      };
    },
    merchantTableRecordSetTableCommissionUser: async (n, l = {}) => {
      v("merchantTableRecordSetTableCommissionUser", "tableCommissionUserDTO", n);
      const t = new URL("/merchant/table/record/set_commission_user", p);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...l
      }, o = {}, c = {};
      o["Content-Type"] = "application/json", R(t, c);
      let s = a && a.headers ? a.headers : {};
      return e.headers = {
        ...o,
        ...s,
        ...l.headers
      }, e.data = M(n, e, r), {
        url: O(t),
        options: e
      };
    },
    merchantTableRecordUpdateMovingTableBillingType: async (n, l = {}) => {
      v("merchantTableRecordUpdateMovingTableBillingType", "movingTableBillingTypeUpdateRequest", n);
      const t = new URL("/merchant/table/record/moving/billing-type", p);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...l
      }, o = {}, c = {};
      o["Content-Type"] = "application/json", R(t, c);
      let s = a && a.headers ? a.headers : {};
      return e.headers = {
        ...o,
        ...s,
        ...l.headers
      }, e.data = M(n, e, r), {
        url: O(t),
        options: e
      };
    },
    merchantTableRecordUpdateTableRecord: async (n, l = {}) => {
      v("merchantTableRecordUpdateTableRecord", "merchantTableRecord", n);
      const t = new URL("/merchant/table/record/update", p);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...l
      }, o = {}, c = {};
      o["Content-Type"] = "application/json", R(t, c);
      let s = a && a.headers ? a.headers : {};
      return e.headers = {
        ...o,
        ...s,
        ...l.headers
      }, e.data = M(n, e, r), {
        url: O(t),
        options: e
      };
    }
  };
}, b = function(r) {
  const n = P(r);
  return {
    async merchantTableRecordCancelTableRecord(l, t, a) {
      var e, o;
      const c = await n.merchantTableRecordCancelTableRecord(l, t, a), s = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, d = (o = h["MerchantTableRecordApi.merchantTableRecordCancelTableRecord"]) === null || o === void 0 || (o = o[s]) === null || o === void 0 ? void 0 : o.url;
      return (i, y) => m(c, u, T, r)(i, d || y);
    },
    async merchantTableRecordMovingTableJson(l, t) {
      var a, e;
      const o = await n.merchantTableRecordMovingTableJson(l, t), c = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, s = (e = h["MerchantTableRecordApi.merchantTableRecordMovingTableJson"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => m(o, u, T, r)(d, s || i);
    },
    async merchantTableRecordOpenTable(l, t, a, e, o) {
      var c, s;
      const d = await n.merchantTableRecordOpenTable(l, t, a, e, o), i = (c = r == null ? void 0 : r.serverIndex) !== null && c !== void 0 ? c : 0, y = (s = h["MerchantTableRecordApi.merchantTableRecordOpenTable"]) === null || s === void 0 || (s = s[i]) === null || s === void 0 ? void 0 : s.url;
      return (V, U) => m(d, u, T, r)(V, y || U);
    },
    async merchantTableRecordOpenTableByCustomer(l, t, a, e) {
      var o, c;
      const s = await n.merchantTableRecordOpenTableByCustomer(l, t, a, e), d = (o = r == null ? void 0 : r.serverIndex) !== null && o !== void 0 ? o : 0, i = (c = h["MerchantTableRecordApi.merchantTableRecordOpenTableByCustomer"]) === null || c === void 0 || (c = c[d]) === null || c === void 0 ? void 0 : c.url;
      return (y, V) => m(s, u, T, r)(y, i || V);
    },
    async merchantTableRecordPreviewMovingTableBilling(l, t) {
      var a, e;
      const o = await n.merchantTableRecordPreviewMovingTableBilling(l, t), c = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, s = (e = h["MerchantTableRecordApi.merchantTableRecordPreviewMovingTableBilling"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => m(o, u, T, r)(d, s || i);
    },
    async merchantTableRecordPreviewMovingTableBillingTypeUpdate(l, t) {
      var a, e;
      const o = await n.merchantTableRecordPreviewMovingTableBillingTypeUpdate(l, t), c = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, s = (e = h["MerchantTableRecordApi.merchantTableRecordPreviewMovingTableBillingTypeUpdate"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => m(o, u, T, r)(d, s || i);
    },
    async merchantTableRecordRollbackMovingTable(l, t) {
      var a, e;
      const o = await n.merchantTableRecordRollbackMovingTable(l, t), c = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, s = (e = h["MerchantTableRecordApi.merchantTableRecordRollbackMovingTable"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => m(o, u, T, r)(d, s || i);
    },
    async merchantTableRecordSetTableCommissionUser(l, t) {
      var a, e;
      const o = await n.merchantTableRecordSetTableCommissionUser(l, t), c = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, s = (e = h["MerchantTableRecordApi.merchantTableRecordSetTableCommissionUser"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => m(o, u, T, r)(d, s || i);
    },
    async merchantTableRecordUpdateMovingTableBillingType(l, t) {
      var a, e;
      const o = await n.merchantTableRecordUpdateMovingTableBillingType(l, t), c = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, s = (e = h["MerchantTableRecordApi.merchantTableRecordUpdateMovingTableBillingType"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => m(o, u, T, r)(d, s || i);
    },
    async merchantTableRecordUpdateTableRecord(l, t) {
      var a, e;
      const o = await n.merchantTableRecordUpdateTableRecord(l, t), c = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, s = (e = h["MerchantTableRecordApi.merchantTableRecordUpdateTableRecord"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => m(o, u, T, r)(d, s || i);
    }
  };
}, A = function(r, n, l) {
  const t = b(r);
  return {
    merchantTableRecordCancelTableRecord(a, e) {
      return t.merchantTableRecordCancelTableRecord(a.tableRecordId, a.cancelReason, e).then((o) => o(l, n));
    },
    merchantTableRecordMovingTableJson(a, e) {
      return t.merchantTableRecordMovingTableJson(a.movingTableParamDTO, e).then((o) => o(l, n));
    },
    merchantTableRecordOpenTable(a, e) {
      return t.merchantTableRecordOpenTable(a.merchantTableRecord, a.clientRequestTime, a.openTableType, a.reserveId, e).then((o) => o(l, n));
    },
    merchantTableRecordOpenTableByCustomer(a, e) {
      return t.merchantTableRecordOpenTableByCustomer(a.merchantTableRecord, a.openTableType, a.reserveId, e).then((o) => o(l, n));
    },
    merchantTableRecordPreviewMovingTableBilling(a = {}, e) {
      return t.merchantTableRecordPreviewMovingTableBilling(a.movingTableParamDTO, e).then((o) => o(l, n));
    },
    merchantTableRecordPreviewMovingTableBillingTypeUpdate(a, e) {
      return t.merchantTableRecordPreviewMovingTableBillingTypeUpdate(a.movingTableBillingTypeUpdateRequest, e).then((o) => o(l, n));
    },
    merchantTableRecordRollbackMovingTable(a, e) {
      return t.merchantTableRecordRollbackMovingTable(a.movingTableRollbackRequest, e).then((o) => o(l, n));
    },
    merchantTableRecordSetTableCommissionUser(a, e) {
      return t.merchantTableRecordSetTableCommissionUser(a.tableCommissionUserDTO, e).then((o) => o(l, n));
    },
    merchantTableRecordUpdateMovingTableBillingType(a, e) {
      return t.merchantTableRecordUpdateMovingTableBillingType(a.movingTableBillingTypeUpdateRequest, e).then((o) => o(l, n));
    },
    merchantTableRecordUpdateTableRecord(a, e) {
      return t.merchantTableRecordUpdateTableRecord(a.merchantTableRecord, e).then((o) => o(l, n));
    }
  };
}, w = class extends B {
  merchantTableRecordCancelTableRecord(r, n) {
    return b(this.configuration).merchantTableRecordCancelTableRecord(r.tableRecordId, r.cancelReason, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordMovingTableJson(r, n) {
    return b(this.configuration).merchantTableRecordMovingTableJson(r.movingTableParamDTO, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordOpenTable(r, n) {
    return b(this.configuration).merchantTableRecordOpenTable(r.merchantTableRecord, r.clientRequestTime, r.openTableType, r.reserveId, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordOpenTableByCustomer(r, n) {
    return b(this.configuration).merchantTableRecordOpenTableByCustomer(r.merchantTableRecord, r.openTableType, r.reserveId, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordPreviewMovingTableBilling(r = {}, n) {
    return b(this.configuration).merchantTableRecordPreviewMovingTableBilling(r.movingTableParamDTO, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordPreviewMovingTableBillingTypeUpdate(r, n) {
    return b(this.configuration).merchantTableRecordPreviewMovingTableBillingTypeUpdate(r.movingTableBillingTypeUpdateRequest, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordRollbackMovingTable(r, n) {
    return b(this.configuration).merchantTableRecordRollbackMovingTable(r.movingTableRollbackRequest, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordSetTableCommissionUser(r, n) {
    return b(this.configuration).merchantTableRecordSetTableCommissionUser(r.tableCommissionUserDTO, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordUpdateMovingTableBillingType(r, n) {
    return b(this.configuration).merchantTableRecordUpdateMovingTableBillingType(r.movingTableBillingTypeUpdateRequest, n).then((l) => l(this.axios, this.basePath));
  }
  merchantTableRecordUpdateTableRecord(r, n) {
    return b(this.configuration).merchantTableRecordUpdateTableRecord(r.merchantTableRecord, n).then((l) => l(this.axios, this.basePath));
  }
};
export {
  w as MerchantTableRecordApi,
  P as MerchantTableRecordApiAxiosParamCreator,
  A as MerchantTableRecordApiFactory,
  b as MerchantTableRecordApiFp
};

//# sourceMappingURL=merchant-table-record-api.js.map